import { Divider } from 'antd';
import type { FC } from 'react';
import type { LossAndDamageClaimPrintFormInfo } from '../../types';
import LADPrintClaim from './LADPrintClaim';

interface LADMultiplePrintClaimsProps {
  claims: LossAndDamageClaimPrintFormInfo[];
}

const LADMultiplePrintClaims: FC<LADMultiplePrintClaimsProps> = ({ claims }) => {
  return (
    <div className="px-50">
      {claims.map((data) => (
        <div key={data.claimNumber}>
          <LADPrintClaim claimData={data} />
          <Divider className="mt-15 mb-30" />
        </div>
      ))}
    </div>
  );
};

export default LADMultiplePrintClaims;
